import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiConfiguration } from '@/core/api/api-configuration';
import { BaseService } from '@/core/api/base-service';
import { environment } from '@env/environment';
import { SICOM_PATHS } from 'src/sicom-paths';
import { ReportOficioDeferimentoPjRequest, ReportOficioDeferimentoPjResponse, ReportJobCreatedResponse, ReportJobStatusResponse } from './oficio-deferimento-pj.model';

/** Cliente HTTP do relatório assíncrono Ofício de Deferimento PJ. */
@Injectable({ providedIn: 'root' })
export class OficioDeferimentoPjService extends BaseService {
    readonly PATH = SICOM_PATHS.registro.prestador.reports.oficioDeferimentoPj;

    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }

    exportarPdf(request: ReportOficioDeferimentoPjRequest): Observable<HttpResponse<ReportOficioDeferimentoPjResponse | ReportJobCreatedResponse>> {
        return this.http.post<ReportOficioDeferimentoPjResponse | ReportJobCreatedResponse>(`${this.PATH}/exportar-pdf`, request, { observe: 'response' });
    }

    iniciarGeracaoAssincrona(request: ReportOficioDeferimentoPjRequest): Observable<ReportJobCreatedResponse> {
        return this.http.post<ReportJobCreatedResponse>(`${this.PATH}/exportar-pdf-async`, request);
    }

    consultarStatus(jobId: string): Observable<ReportJobStatusResponse> {
        return this.http.get<ReportJobStatusResponse>(`${this.PATH}/job/${jobId}/status`);
    }

    baixarPdf(jobId: string): Observable<ArrayBuffer> {
        return this.http.get(`${this.PATH}/job/${jobId}/download`, { responseType: 'arraybuffer' });
    }
}
